import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TGetInvoiceTemplatesResponse } from "./getInvoiceTemplatesRequest.schema";

/**
 * @description
 * Fetches all invoice templates for a company.
 * Optionally filters templates by a search string (matches template or customer names).
 *
 * Sends GET request to la-forge route:
 * GET /api/invoices/templates?companyID={companyID}&search={search}
 *
 * @param axios - injected axios instance from AbstractApiClient
 * @param companyID - company ID for which to fetch invoice templates
 * @param search - optional search string to filter templates
 * @returns list of invoice templates with name, customer_count, and customers
 */
export const getInvoiceTemplates =
  (axios: IAxiosInstance) =>
  async (
    companyID: string,
    search: string = ""
  ): Promise<TGetInvoiceTemplatesResponse> => {
    const response = await axios.noRetry.get("/api/invoices/templates", {
      params: { companyID, search },
    });

    const resData = response.data;

    if (resData?.success) {
      return resData.data;
    }

    throw new Error(resData?.error || "Error fetching invoice templates");
  };
